<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search"
        @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="6" :sm="12">
            <el-form-item label="物品名称:">
              <el-input v-model="table.where.itemName" placeholder="请输入物品名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="物品编码:">
              <el-input v-model="table.where.code" placeholder="请输入物品编码" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="操作人:">
              <el-input v-model="table.where.createUser" placeholder="姓名-手机号" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="教师姓名:">
              <el-input v-model="table.where.teacherName" placeholder="分配教师姓名" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :md="8" :sm="12">
            <el-form-item label="时间范围:">
              <el-date-picker v-model="daterange" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd" class="ele-fluid" @change="onDateChange" />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="操作内容:">
              <el-input v-model="table.where.desc" placeholder="操作内容" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="10" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                class="ele-btn-icon">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
              <el-button type="warning" @click="handleExport" icon="el-icon-download"
                class="ele-btn-icon">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="50" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="itemCode" label="物品编码" sortable="custom" show-overflow-tooltip min-width="120" />
          <el-table-column prop="itemName" label="物品名称" sortable="custom" show-overflow-tooltip min-width="130" />
          <el-table-column prop="typeName" label="类别" show-overflow-tooltip min-width="100" />
          <el-table-column prop="description" label="操作内容" show-overflow-tooltip min-width="180" />
          <el-table-column prop="num" label="数量" align="center" width="80" />
          <el-table-column prop="createUser" label="操作人" show-overflow-tooltip width="130" />
          <el-table-column prop="createTime" label="操作时间" show-overflow-tooltip min-width="160" />
        </template>
      </ele-data-table>
    </el-card>
  </div>
</template>

<script>
import { exportLog } from '@/config/assetApi';

export default {
  name: 'AssetLog',
  data () {
    return {
      table: {
        url: '/asset/logList',
        where: {
          page: 1,
          limit: 10,
        },
        page: true,
        parseData (res) {
          if (res.data && res.resCode == 200) {
            res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          } else {
            res.code = 1;
            res.data = [];
            res.count = 0;
          }
          return res;
        },
      },
      choose: [],
      daterange: null,
    };
  },
  methods: {
    onDateChange (val) {
      if (val) {
        this.table.where.startTime = val[0];
        this.table.where.endTime = val[1];
      } else {
        this.table.where.startTime = '';
        this.table.where.endTime = '';
      }
    },
    handleReset () {
      this.table.where = { page: 1, limit: 10 };
      this.daterange = null;
      this.$refs.table.reload();
    },
    handleExport () {
      const params = { ...this.table.where };
      delete params.page;
      delete params.limit;
      exportLog(params).then((res) => {
        let blob = new Blob([res.data], { type: 'application/octet-stream' });
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '操作日志.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      });
    },
  },
};
</script>

<style scoped></style>
